import { z } from "zod";

export const contactSchema = z.object({
  name: z.string().min(2, "Please enter your name"),
  email: z.string().email("Please enter a valid email address"),
  company: z.string().optional(),
  subject: z.string().min(5, "Please provide a subject (at least 5 characters)"),
  message: z
    .string()
    .min(20, "Please write at least 20 characters so we understand your enquiry"),
});

export type ContactFormValues = z.infer<typeof contactSchema>;
